module.exports = __webpack_public_path__ + "9785ba1d76aabb84e32938549bb3ce75.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/projekte/lankenau01.jpg
// module id = 516
// module chunks = 0